<template>
  <div>
    <b-dropdown position="is-bottom-left" append-to-body aria-role="menu" trap-focus ref="filterRef">
      <b-button
        slot="trigger"
        type="is-info"
        icon-left="filter">
          Filtrar
      </b-button>
      <b-dropdown-item
        aria-role="menu-item"
        :focusable="false"
        custom
        paddingless>
          <form action="">
            <!-- <header class="modal-card-head filter-content-padding">
            </header> -->
            <div class="modal-card" style="width:auto;">
                <section class="modal-card-body filter-content-padding">
                  <b-field label="Estado">
                    <b-field>
                        <b-radio-button v-model="active"
                            :native-value="null"
                            type="is-primary">
                            <b-icon icon="account-group"></b-icon>
                            <span>Todos</span>
                        </b-radio-button>

                        <b-radio-button v-model="active"
                            :native-value="1"
                            type="is-primary">
                            <b-icon icon="account-multiple-check"></b-icon>
                            <span>Activos</span>
                        </b-radio-button>

                        <b-radio-button v-model="active"
                            :native-value="2"
                            type="is-primary">
                            <b-icon icon="account-multiple-remove"></b-icon>
                            <span>Inactivos</span>
                        </b-radio-button>
                    </b-field>
                  </b-field>
                </section>
                <footer class="modal-card-foot filter-content-padding" style="justify-content: center;">
                  <!-- <button class="button is-default">Restaurar</button> -->
                  <b-button type="is-default" rounded expanded @click="restart" aria-role="menu-item">Restaurar</b-button>
                  <b-button type="is-primary" rounded expanded @click="apply" aria-role="menu-item">Aplicar</b-button>
                </footer>
            </div>
          </form>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  created () {
    this.apply()
  },
  data () {
    return {
      active: 1
    }
  },
  methods: {
    apply () {
      let filters = this.getFilters()
      if (this.$refs.filterRef) {
        this.$refs.filterRef.toggle()
      }
      this.$emit('filtered', filters)
    },
    restart () {
      this.active = null
      this.apply()
    },
    getFilters () {
      let filters = {
        'user_status_id': this.active
      }
      return filters
    }
  }
}
</script>

<style >
  .dropdown-content{
   /* padding-top: 0px !important; */
    padding-bottom: 0px !important;
    -webkit-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
  }
  .filter-content-padding{
    padding: 10px 15px;
  }
</style>
